import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const ConfirmationDialog = ({ open, onClose, onConfirm, contentAI, maker }) => {
  const [hasDeletePermission, setHasDeletePermission] = useState(true);
  const api = localStorage.getItem("api");
  const headers = useSelector((state) => state?.header);
  const user = useSelector((state) => state?.user?.user);
  const groupIdsOfUser = user?.customProperties?.belongsTo || [];

  useEffect(() => {
    const checkPrivileges = async () => {
      if (!contentAI || !maker) return;

      try {
        const response = await axios.get(
          `${api}/user/getgroupid?email=${maker}`,
          headers
        );

        const makerGroupIds = response?.data || [];
        const match = makerGroupIds.some((id) => groupIdsOfUser.includes(id));

        setHasDeletePermission(match);
      } catch (error) {
        console.error("Error checking permissions:", error);
        setHasDeletePermission(false);
      }
    };

    checkPrivileges();
  }, [maker, contentAI, api, headers, groupIdsOfUser]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ color: "#721c24", fontWeight: "bold" }}>
        Confirmation
      </DialogTitle>
      <DialogContent sx={{ paddingY: 2 }}>
        {contentAI && !hasDeletePermission ? (
          <Typography variant="body1" color="error">
            You do not have permission to delete this item.
          </Typography>
        ) : (
          <>
            <Typography variant="body1" color="textPrimary" sx={{ mb: 1 }}>
              Are you sure you want to delete?
            </Typography>
            {contentAI && (
              <Typography variant="body2" color="warning.main">
                ⚠️ Deleting this might affect events linked to it.
              </Typography>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: "12px" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{ color: "success", borderColor: "#6c757d" }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="outlined"
          color="error"
          disabled={contentAI && !hasDeletePermission}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
